import type EventEmitter from '../common/eventEmitter';
import type { ITimezoneConfig } from '../../interface/ITimezone';

class TimezoneBtn {
  $element!: HTMLElement;

  $btn!: HTMLButtonElement;

  config!: ITimezoneConfig;

  emitter!: EventEmitter;

  #isActive: boolean = false;

  constructor(config: ITimezoneConfig, emitter: EventEmitter) {
    if(!config) {
      console.error('config 를 확인해주세요.', config, parent);
      return;
    }

    this.config = config;
    this.emitter = emitter;
    this.init();
  }

  init() {
    this.render();
    this.addEvent();
  }

  render() {
    const div = document.createElement('div');
    const btn = document.createElement('button');
    div.classList.add('ncui-timezone-btn');
    btn.innerText = this.config?.btnName || 'BUTTON';
    btn.classList.add('btn-timezone');
    div.append(btn);
    this.$element = div;
    this.$btn = btn;
  }

  addEvent() {
    this.emitter?.addEvent('CHANGE_BTN_ISACTIVE', (isActive: boolean) => {
      isActive ? this.$btn.classList.add('active') : this.$btn.classList.remove('active');
      this.#isActive = isActive;
    });

    this.$btn.addEventListener('click', e => {
      const isActive = !this.#isActive;
      this.emitter?.emit('CLICK_TIMEZONE_BTN', isActive);
      this.emitter?.emit('CHANGE_BTN_ISACTIVE', isActive);
    });
  }

  get element() {
    return this.$element;
  }

  get isActive() {
    return this.#isActive;
  }

  set isActive(isActive: boolean) {
    this.emitter?.emit('CHANGE_BTN_ISACTIVE', isActive);
  }
}

export default TimezoneBtn;